
// Shoppable videos popup

const show_video = (button, index ) => {
  // === This opens up the video popup and plays the video
  mute_banner_video(button, false);
  document.querySelector(".tolstoy-app-videos-popup-container-fixed").classList.add("active");
  document.querySelectorAll(".video-carousel-videos-items video").forEach(video => video.pause());
  play_video(index, "");
  check_video_ended();

  console.log(index)

  if ( document.querySelector(".tolstoy-app-videos-popup-lists-item.item-"+index+" .products-list") == null ) {
    document.querySelector('.dropdown-btn').classList.add('active');
    document.querySelector('.dropdown-btn').style.display = 'none';
    document.querySelector('.tolstoy-app-videos-popup-mute').classList.add('active');
  }
  else {
    if ( document.querySelector(".tolstoy-app-videos-popup-lists-item.item-"+index+" .products-list").style.display == "none" ) {
      document.querySelector('.dropdown-btn').classList.add('active');
      document.querySelector('.dropdown-btn').style.display = 'flex';
      document.querySelector('.tolstoy-app-videos-popup-mute').classList.add('active');
    }
    else {
      document.querySelector('.dropdown-btn').classList.remove('active');
      document.querySelector('.dropdown-btn').style.display = 'flex';
      document.querySelector('.tolstoy-app-videos-popup-mute').classList.remove('active'); 
    }
  }
}

const hide_video = () => {
  // === This closes the video popup and stops the video
  
  document.querySelector(".tolstoy-app-videos-popup-container-fixed").classList.remove("active");
  // document.querySelectorAll(".video-carousel-videos-items video")[0].play();
  stop_videos();
}

const stop_videos = () => {
  // === This pauses ALL videos 
  
  const videos = document.querySelectorAll(".tolstoy-app-videos-popup-lists-item video");
  videos.forEach(video => video.pause());
}

const pause_video = ( index ) => {
  // === This pauses ALL videos when user clicks

  // play video
  const chosen_video = document.querySelector(`.tolstoy-app-videos-popup-lists-item.item-${ index }`);
  
  if ( chosen_video.querySelector("video").paused ) {
    play_video(index, "");
  }
  else {
    chosen_video.insertAdjacentHTML(
      "afterbegin",
      `<svg class="tolstoy-app-videos-list-item-play" width="90" height="90" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" style=" position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); "><path d="M60 114.546c30.125 0 54.546-24.421 54.546-54.546S90.125 5.455 60 5.455 5.455 29.875 5.455 60 29.875 114.546 60 114.546Z" fill="#090A0B99"></path><path d="M50.387 85.167c-3.142 0-5.387-2.47-5.387-5.387V40.275C45 37.469 47.245 35 50.387 35c.898 0 1.908.224 2.806.786l32.322 19.752c1.571.898 2.581 2.694 2.581 4.49 0 1.907-1.01 3.703-2.581 4.6L53.193 84.382a5.33 5.33 0 0 1-2.806.786Z" fill="#fff"></path><defs><linearGradient id="player-button-s" x1="60" y1="5.455" x2="83.619" y2="46.363" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#198DEE"></stop><stop offset="0.5" stop-color="#2A3CEF"></stop></linearGradient><linearGradient id="player-button-b" x1="107.236" y1="32.727" x2="107.236" y2="87.273" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#2A3CEF"></stop><stop offset="0.7" stop-color="#E124D9"></stop></linearGradient><linearGradient id="player-button-c" x1="107.236" y1="87.273" x2="83.617" y2="128.181" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#E124D9"></stop><stop offset="1" stop-color="#E52E56"></stop></linearGradient><linearGradient id="player-button-d" x1="60" y1="114.546" x2="36.381" y2="73.637" gradientUnits="userSpaceOnUse"><stop offset="0.2" stop-color="#FFB400"></stop><stop offset="1" stop-color="#C4FF29"></stop></linearGradient><linearGradient id="player-button-e" x1="5.456" y1="87.273" x2="5.456" y2="32.727" gradientUnits="userSpaceOnUse"><stop offset="0.1" stop-color="#C4FF29"></stop><stop offset="1" stop-color="#198DEE"></stop></linearGradient><linearGradient id="player-button-f" x1="12.764" y1="32.727" x2="36.383" y2="-8.181" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#198DEE"></stop><stop offset="1" stop-color="#198DEE"></stop></linearGradient></defs></svg>`,
    );
    chosen_video.querySelector("video").pause();
  }
}

const mute_video = () => {
    //  === This mutes the entire video
  
   document.querySelectorAll(".tolstoy-app-videos-popup-mute svg").forEach(svg => svg.classList.toggle("active"));
  
   const videos = document.querySelectorAll(".tolstoy-app-videos-popup-lists-item video");
   videos.forEach(video => video.muted = true);
  
   if ( document.querySelector(".tolstoy-app-videos-popup-mute svg.not-muted").classList.contains("active") ) {
     let i = 0;
     document.querySelectorAll(`.tolstoy-app-videos-popup-lists-item`).forEach((video, index) => video.classList.contains("active") ? i = index : "");
     play_video(i + 1, "");
   }
}

const mute_banner_video = (button, toggle) => {
  // Find the parent container and video element
  const parent = button.closest('.collection__inline-banner');
  const video = parent.querySelector('video');
  
  // Find the mute and unmute icons inside the button
  const muteIcon = parent.querySelector(".muted");
  const unmuteIcon = parent.querySelector(".not-muted");

  // Determine whether to toggle or force mute
  const isMuted = toggle ? !video.muted : true;
  video.muted = isMuted; // Set the muted state

  // Sync SVG visibility
  muteIcon.classList.toggle("active", isMuted);    // Show mute icon when muted
  unmuteIcon.classList.toggle("active", !isMuted); // Show unmute icon when unmuted

  // Sync the muted attribute in the DOM
  if (isMuted) {
    video.setAttribute('muted', ''); // Add the muted attribute
  } else {
    video.removeAttribute('muted'); // Remove the muted attribute
  }
};

const play_video = ( index, type ) => {
  // === This plays the video and goes into view

  const all_video_container = document.querySelectorAll(`.tolstoy-app-videos-popup-lists-item`);
  const video_container = document.querySelector(`.tolstoy-app-videos-popup-lists-item.item-${ index }`);
  const video = document.querySelector(`.tolstoy-app-videos-popup-lists-item.item-${ index } video`);

  all_video_container.forEach(video => video.classList.remove("active"));
  video_container.classList.add("active");
  video_container.querySelector("svg") ? video_container.querySelector("svg").remove() : "";
  
  // pause all video
  stop_videos();

  // play video
  type == "smooth" ? video_container.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" }) : video_container.scrollIntoView({ block: "end", inline: "nearest" });
  
  video.muted = true;
  
  if ( type != "" ) {
    video.currentTime = 0;                
  }
  
  video.play();

  if ( document.querySelector(".tolstoy-app-videos-popup-mute svg.not-muted").classList.contains("active") ) {
    video.muted = false;                 
  }

  if ( document.querySelector(".tolstoy-app-videos-popup-lists-item.item-"+index+" .products-list") == null ) {
    document.querySelector('.dropdown-btn').classList.add('active');
    document.querySelector('.dropdown-btn').style.display = 'none';
    document.querySelector('.tolstoy-app-videos-popup-mute').classList.add('active');
  }
  else {
    if ( document.querySelector(".tolstoy-app-videos-popup-lists-item.item-"+index+" .products-list").style.display == "none" ) {
      document.querySelector('.dropdown-btn').classList.add('active');
      document.querySelector('.dropdown-btn').style.display = 'flex';
      document.querySelector('.tolstoy-app-videos-popup-mute').classList.add('active');
    }
    else {
      document.querySelector('.dropdown-btn').classList.remove('active');
      document.querySelector('.dropdown-btn').style.display = 'flex';
      document.querySelector('.tolstoy-app-videos-popup-mute').classList.remove('active'); 
    }
  }
}

const check_video_ended = () => {
  // === This checks for video ending and goes to the next one

  const videos = document.querySelectorAll(".tolstoy-app-videos-popup-lists .tolstoy-app-videos-popup-lists-item");

  videos.forEach((video, index) => {
    video.querySelector("video").onended = () => {
      let i = index + 2;

      // reset
      if ( i > videos.length ) {
        i = 1;
      }

      document.querySelector(`.tolstoy-app-videos-popup-lists-item.item-${ i }`).scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
      play_video(i, "smooth");
    }
  });
}

const go_to = ( type ) => {
  // === This goes to specific slide 
  const all_video_container = document.querySelectorAll(`.tolstoy-app-videos-popup-lists-item`);
  let i = 0;

  all_video_container.forEach((video, index) => video.classList.contains("active") ? i = index : "");

  if (type == "down") {
    if (i == all_video_container.length - 1) {
      i = 0;
    } else {
      i += 1;                  
    }
  } else {
    if (i == 0) {
      i = all_video_container.length - 1;
    } else {
      i -= 1;                  
    }
  }
  
  // as document start at 1
  i = i + 1;
  play_video(i, "smooth");
}

const run_video_progress = ( e ) => {
  document.querySelector(".tolstoy-app-videos-popup-lists-item.active .progress .bar").style.width = `${ (e.currentTime/e.duration)*100 }%`;
}
